// src/context/RootProvider.jsx
import React from "react";
import { GlobalProvider } from "./GlobalProvider";
import { DashboardProvider } from "./DashboardProvider";

export const RootProvider = ({ children }) => (
  <GlobalProvider>
    <DashboardProvider>
      {children}
    </DashboardProvider>
  </GlobalProvider>
);